const USER_FACING_PAGE_ERROR =
  "Não foi possível carregar a página. Tente novamente em instantes.";

const DEBUG_FLAG_KEY = "fabchat_debug";

/** Ativo só em dev e com flag explícita no localStorage (debug interno). */
export function isInternalDebugEnabled(): boolean {
  if (!import.meta.env.DEV) return false;
  try {
    return localStorage.getItem(DEBUG_FLAG_KEY) === "1";
  } catch {
    return false;
  }
}

function serializeInternalError(error: unknown): Record<string, unknown> {
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  if (typeof error === "string") return { message: error };
  try {
    return { message: JSON.stringify(error) };
  } catch {
    return { message: String(error) };
  }
}

/** Registra detalhes técnicos apenas no console (nunca na UI do usuário). */
export function logInternalError(scope: string, error: unknown, extra?: unknown): void {
  const payload = {
    scope,
    route: typeof window !== "undefined" ? window.location.pathname : undefined,
    error: serializeInternalError(error),
    extra,
  };
  console.error(`[${scope}]`, payload);
}

export function getUserFacingErrorMessage(
  _error: unknown,
  fallback = USER_FACING_PAGE_ERROR,
): string {
  return fallback;
}

export function getInternalErrorDetails(error: unknown): string | null {
  if (!isInternalDebugEnabled()) return null;
  if (error instanceof Error) return error.message;
  if (typeof error === "string") return error;
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}
